import * as React from 'react';

type PropsT = {
  children: React.ReactNode;
  className?: string;
};

export class Icons extends React.PureComponent<PropsT> {
  render() {
    const { children, className, ...otherProps } = this.props;

    return <div {...otherProps}>{children}</div>;
  }
}
